import { Wrapper, ContentTypeRender } from "nystem-components";

const StyleView = ({ model, path }) => {
  const { className, renderAs, item, title, id } = model;

  return (
    <Wrapper className={className} renderAs={renderAs} title={title} {...(id ? { id } : {})}>
      <ContentTypeRender path={path} items={item} />
    </Wrapper>
  );
};

export default StyleView;
